import {Enum} from '../base/base.enum';

export class ExceptionErrorCodesEnum extends Enum {
    protected static LABEL_KEY_BASE: string = 'ENUMS.EXCEPTION_ERROR_CODES';

    public static readonly VALIDATION = new ExceptionErrorCodesEnum('VALIDATION');
    public static readonly INTERNAL = new ExceptionErrorCodesEnum('INTERNAL');
}
